<template>
  <div>
    <v-toolbar class fixed app id="navmobiledesktop">
      <router-link to="/">
        <img alt="Canvas Development" src="https://ik.imagekit.io/canvasdev/canvasdev-brand-logo_-9ocBKwiJ.png" class="site-logo" />
      </router-link>

      <v-spacer></v-spacer>

      <div class="text-xs-center parent-nav" v-for="(menuLink,i) in menuLinks" v-bind:key="i">
        <router-link
          class="hidden-md-and-down"
          v-if="!menuLink.type"
          :to="menuLink.link"
        >{{menuLink.title}}</router-link>
        <router-link class="hidden-md-and-down" v-else :to="menuLink.link">
          <v-btn
            @click.prevent="scrollDown"
            class="white--text theme-navbtn blueButton"
          ><v-icon :class="menuLink.icon" style="vertical-align: middle; margin-top: -1px; margin-right: 5px;">{{menuLink.icon}}</v-icon>{{menuLink.title}}</v-btn>
        </router-link>

        <v-toolbar-side-icon
          @click="drawer=true"
          class="hidden-lg-and-up"
          v-if="i == menuLinks.length -1"
        ></v-toolbar-side-icon>
      </div>
    </v-toolbar>

    <v-navigation-drawer v-model="drawer" temporary fixed right app class="nav-desktop">
      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <v-list-tile-title class="title">
              <img
                alt="Canvas Development"
                src="https://ik.imagekit.io/canvasdev/canvasdev-brand-logo_-9ocBKwiJ.png"
                class="msite-logo ml-2 mt-0 pl-0"
              />
              <v-icon @click="drawer=!drawer">close</v-icon>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <v-divider></v-divider>

      <v-list dense class="pt-0">
        <v-list-tile v-for="(menuLink, i) in menuLinks" :key="i">
          <v-list-tile-content>
            <v-list-tile-title class="pl-3 mt-3">
              <router-link v-if="!menuLink.type" :to="menuLink.link">{{ menuLink.title }}</router-link>
              <span v-else :to="menuLink.link"  @click.prevent="scrollDown" class="onclick">
              <v-icon :class="menuLink.icon" style="vertical-align: middle; margin-top: -1px; margin-right: 5px; color:#000;">{{menuLink.icon}}</v-icon>{{ menuLink.title }}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      drawer: false
    };
  },
  methods: {
    scrollDown(e) {
      this.drawer = false
      let div = document.querySelector("#contact-form-header").offsetTop;
      window.scrollTo({
        top: div - 100,
        left: 0,
        behavior: "smooth"
      });
    }
  },
  computed: {
    ...mapState(["menuLinks"])
  }
};
</script>

<style lang="css" scoped>
.onclick {cursor: pointer; font-weight: 800;}
.site-logo {
  width: 220px;
  margin-right: 20px;
  margin-top:10px;
}

.msite-logo {
  height: inherit;
  display: inline-block;
  vertical-align: middle;
  margin-right: 160px;
  width: 90px;
  height: 25px;

 
}

.parent-nav a {
  font-size: 16px;
  text-decoration: none;
  text-transform: uppercase;
  display: inline-block;
  padding: 20px;
}

a {
  color: #000;
  /* font-family: "Poppins", sans-serif; */
}

a,
.theme-navbtn {
  font-weight: 700;
  letter-spacing: 0.1em;
}

a:hover {
  color: #1976d2;
}

.v-navigation-drawer a {
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 700;
  color: #000;
}

.blueButton {
  background-color: #172683 !important;
  font-size: 16px;
}

#navmobiledesktop {
  z-index: 99999999999999;
}
</style>
